import { createRouter, createWebHistory } from 'vue-router'

import ViewNatalChartWidget from '../components/ViewNatalChartWidget.vue'

const routes = [
  { path: '/', name: 'Home', component: ViewNatalChartWidget }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
